// FBKS-3962: buckets used by the cart content summary (counts, amounts and list filters).
// Mirrors Offer::UNLIMITED_TOKENS / Offer::UNLIMITED_LIFETIME / Copy::FINITE_RANGE.
const UNLIMITED_TOKENS = [0, 99, 999, 9999, 99999, 999999];
const COPY_FINITE_TOKENS = [1, 998];
const UNLIMITED_LIFETIME = [0, 999999];
const UNLIMITED_CONCURRENT_USERS = [0, 999999];

export const CHILDREN_AUDIENCES = ['advanced_reader', 'beginner_reader', 'early_childhood'];

const CATEGORIES = { FBFIC000000: 'fiction', FBNFC000000: 'non_fiction' };

// Copy tokens are multiplied by quantity (33 x 3 = 99 is finite), so they use Copy::FINITE_RANGE
const unlimitedTokens = ({ tokens, from_copy }) => {
  return from_copy ? !(tokens >= COPY_FINITE_TOKENS[0] && tokens <= COPY_FINITE_TOKENS[1]) : UNLIMITED_TOKENS.includes(tokens);
};

export const licenseModel = (offer) => {
  const { lifetime, concurrent_users } = offer;
  if (UNLIMITED_CONCURRENT_USERS.includes(concurrent_users)) return 'concurrent_access';
  if (!unlimitedTokens(offer)) return 'limited_loans';
  if (!UNLIMITED_LIFETIME.includes(lifetime)) return 'limited_duration';
  return 'perpetual';
};

const audience = ({ age, classifications = {} }) => {
  return Object.keys(classifications).find(key => classifications[key] === age);
};

export const summaryKeys = (item) => ({
  license_model: licenseModel(item.offer),
  format: item.offer.format,
  audience: audience(item.publication),
  category: CATEGORIES[item.publication.categories?.[0]],
  language: item.publication.language,
  review: [
    !item.offer.available && 'unavailable',
    item.publication.already_purchased && 'already_purchased',
    item.publication.in_another_cart && 'in_another_cart'
  ].filter(Boolean)
});

export const matchesSummaryFilter = (keys, group, value) => {
  if (group === 'review') return keys.review.includes(value);
  if (group === 'audience' && value === 'children') return ['children', ...CHILDREN_AUDIENCES].includes(keys.audience);
  return keys[group] === value;
};

export const matchesSummaryFilters = (keys, filters) => filters.some(({ group, value }) => matchesSummaryFilter(keys, group, value));

// Tax-excluded line amount in the billing currency. Per-line pricing already converts it,
// per-cart (legacy) pricing is converted with the cart exchange rates, as CartPriceDetail does.
export const lineAmount = (item, exchangeRates = {}) => {
  if (item.only_offer_deleted || !item.original_offer || !item.price) return 0;
  const { converted_price_without_taxes, price_without_taxes, currency } = item.price;
  const unitPrice = converted_price_without_taxes ?? (price_without_taxes || 0) * (exchangeRates[currency] ?? 1);
  return unitPrice * (item.offer.quantity || 0);
};
